
import React, { useState, useEffect } from "react";
import { get } from "lodash";
import axios from "../../axios";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import './CommissionSettings.css';
import Cookies from "js-cookie";
import Select from "react-select";
import { toast } from "react-toastify";
import { bottom } from "@popperjs/core";
import Input from "../../components/Input";
import { Modal } from "../../components/Modal";
import Overlay from "../../components/Overlay";
import InputLogin from "../../components/InputLogin";
import { Field, Form, Formik } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import { extractDate, uploadImage, subadminAccessChange } from "../../utils/functions";

// Mui & material UI
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import SearchBar from "material-ui-search-bar";
import FormGroup from "@mui/material/FormGroup";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Paper } from "@material-ui/core";

// icons
import { SlClose } from "react-icons/sl";
import { IoIosLogOut } from "react-icons/io";
import { TiInfoOutline } from "react-icons/ti";
import { GrApple, GrAndroid } from "react-icons/gr";
import { BsDot, BsEyeFill, BsPlus, BsThreeDotsVertical } from "react-icons/bs";
import { MdBlock, MdClose, MdEmail, MdLocalPhone, MdPhone } from "react-icons/md";
import { FaFilter, FaGlobe, FaPhone, FaUser, FaUserAlt, FaArrowLeft } from "react-icons/fa";
import { IoArchive, IoArrowBackCircleOutline, IoArrowForwardCircleOutline } from "react-icons/io5";

// Elements
import {
    DashboardContainer,
    DashboardWrapper,
    DashboardHeading,
    Button,
    CancelButton,
    ProfileDetailForm,
} from "./CommitionElements";

const useStyles = makeStyles((theme) => ({
    paperTableHeight: {
        width: "97%",
        marginLeft: "1rem",
        // minHeight: "87vh",
        border: "1px solid rgba(12, 45, 6, 0.10)",
        borderRadius: "10px",
    },
    formStyle: {
        width: "100%",
        padding: "2rem",
        overflow: "scroll",
    },
    formStyleOnly: {
        width: "100%",
    },
}));

const CommissionSettings = ({ setUsers, userData }) => {
    const adminData = JSON.parse(localStorage.getItem("userData") || userData || sessionStorage.getItem("userData"));

    const commissionManagementPermissions = adminData?.adminpermissions?.modules?.find(
        (module) => module.moduleName === "Commission Management"
    )?.permissions || {};

    const canView = !!commissionManagementPermissions.view;
    const canAdd = !!commissionManagementPermissions.add;
    const canEdit = !!commissionManagementPermissions.edit;
    const canDelete = !!commissionManagementPermissions.delete;
    const canBlockUnblock = !!commissionManagementPermissions.blockUnblock;

    const isDisabled = !canEdit && adminData?.userType === "subAdmin";


    const classes = useStyles();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [commissionData, setCommissionData] = useState({});

    // Get user data
    useEffect(() => {
        getCommissionData();
    }, []);

    const getCommissionData = async () => {
        setIsLoading(true);

        try {
            const { data } = await axios.get(`/private/getfare`);

            setCommissionData(data?.data);
        } catch (error) {
            if (error?.response?.status === 901) {
                subadminAccessChange(navigate);
                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });
            } else if (error?.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                setUsers("");

                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });

                navigate("/");
            } else {
                console.log("error", error?.response)
            }
        } finally {
            setIsLoading(false);
        }
    };





    const updateCommissionSettingsData = async (values) => {
        setIsLoading(true);

        const formattedValues = {
            amount: values.amount,
            cuponDiscount: values.cuponDiscount,
            frequency: values.frequency,
            taxPercentage: values.taxPercentage

            // rewardType: values.rewardType,
            // rewardValue: values.rewardValue,
            // afterJobCompEH: values.afterJobCompEH,
            // extraHours: values.extraHours,
        };

        try {
            const { data } = await axios.post(`/private/updateFare/${commissionData?._id}`, formattedValues);

            toast.success(`${data?.message}`, { position: "top-right" });
            getCommissionData();

        } catch (error) {
            if (error?.response?.status === 901) {
                subadminAccessChange(navigate);
                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });
            }
            else if (error?.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                setUsers("");

                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });

                navigate("/");
            } else if (error?.response?.status === 422) {
                toast.error(`${error.response.data?.errors[0]?.msg}`, {
                    position: "top-right",
                });
            } else {
                console.log("error", error?.response)
            }
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <>
            <DashboardContainer>
                <DashboardWrapper >
                    <ProfileDetailForm>

                        <div className="common-heading">Payment Method</div>

                        <DashboardHeading>
                            <div className="common-heading-name">Admin Commission</div>

                            <Formik
                                enableReinitialize
                                initialValues={{
                                    amount: commissionData?.amount || "",
                                    taxPercentage: commissionData?.taxPercentage || "",
                                    frequency: commissionData?.frequency || "",
                                    cuponDiscount: commissionData?.cuponDiscount || "",


                                }}
                                validate={(values) => {
                                    const errors = {};

                                    // Validate `adminCommissionFee`
                                    if (!values.amount) {
                                        errors.amount = "Admin Commission Fee is required";
                                    } else if (parseFloat(values.amount) < 0) {
                                        errors.amount = "Admin Commission Fee cannot be negative";
                                    }

                                    // Validate `frequency`
                                    if (!values.frequency) {
                                        errors.frequency = "Frequency  is required";
                                    } else if (parseFloat(values.frequency) < 0) {
                                        errors.frequency = "Frequency cannot be negative";
                                    }

                                    // Validate `cuponDiscount`
                                    if (!values.cuponDiscount) {
                                        errors.cuponDiscount = "Coupon Discount is required";
                                    } else if (parseFloat(values.cuponDiscount) < 0) {
                                        errors.cuponDiscount = "Coupon Discount cannot be negative";
                                    }

                                    // Validate `cuponDiscount`
                                    if (!values.taxPercentage) {
                                        errors.taxPercentage = "Tax Percentage is required";
                                    } else if (parseFloat(values.taxPercentage) < 0) {
                                        errors.taxPercentage = "Tax Percentage cannot be negative";
                                    }


                                    return errors;
                                }}
                                onSubmit={(values) => {
                                    updateCommissionSettingsData(values);
                                }}
                            >



                                {(formikBag) => {
                                    return (
                                        <Form className={classes.formStyleOnly}>
                                            <div className="fare-section">

                                                {/* Admin Commission Fee */}
                                                <div className="fare-container">
                                                    <div className="row col-md-12">
                                                        <div className="col-md-3">
                                                            <div style={{ display: "flex", flexDirection: "column", gap: "0.8rem" }}>
                                                                <label className="fare-label-name-data">Amount (in %)</label>
                                                                <Field name="amount" >
                                                                    {({ field }) => (
                                                                        <Input
                                                                            {...field}
                                                                            type="number"
                                                                            min="1"
                                                                            disabled={isDisabled}
                                                                            onChange={(e) => {
                                                                                if (!isDisabled) {
                                                                                    formikBag.setFieldValue("amount", e.target.value);
                                                                                }
                                                                            }}
                                                                            className="form_data"
                                                                            placeholder="Enter Amount"
                                                                            style={{ width: "23rem" }}
                                                                            error={
                                                                                formikBag.touched.amount && formikBag.errors.amount
                                                                                    ? formikBag.errors.amount
                                                                                    : null
                                                                            }
                                                                        />
                                                                    )}
                                                                </Field>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                  {/* Reward Section */}
                                                <div className="common-heading-name">Tax </div>
                                                <div className="fare-container">
                                                    <div className="row col-md-12">
                                                        <div className="col-md-3" style={{ display: "flex", gap: "2rem" }}>

                                                            <div style={{ display: "flex", flexDirection: "column", gap: "0.8rem" }}>
                                                                <label className="fare-label-name-data">Tax Percentage [in %]</label>
                                                                <Field name="taxPercentage">
                                                                    {({ field }) => (
                                                                        <Input
                                                                            {...field}
                                                                            type="number"
                                                                            min="1"
                                                                            max="100"
                                                                            disabled={isDisabled}
                                                                            onChange={(e) => {
                                                                                const rawValue = e.target.value;

                                                                                if (rawValue === "") {
                                                                                    formikBag.setFieldValue("taxPercentage", "");
                                                                                } else {
                                                                                    const value = Number(rawValue);
                                                                                    if (!isDisabled && value <= 100) {
                                                                                        formikBag.setFieldValue("taxPercentage", value);
                                                                                    }
                                                                                }
                                                                            }}
                                                                            className="form_data"
                                                                            placeholder="Enter percentage"
                                                                            style={{ width: "23rem" }}
                                                                            error={
                                                                                formikBag.touched.taxPercentage && formikBag.errors.taxPercentage
                                                                                    ? formikBag.errors.taxPercentage
                                                                                    : null
                                                                            }
                                                                        />
                                                                    )}
                                                                </Field>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Reward Section */}
                                                <div className="common-heading-name">Reward Per Referral</div>
                                                <div className="fare-container">
                                                    <div className="row col-md-12">
                                                        <div className="col-md-3" style={{ display: "flex", gap: "2rem" }}>

                                                            <div style={{ display: "flex", flexDirection: "column", gap: "0.8rem" }}>
                                                                <label className="fare-label-name-data">Reward Type</label>
                                                                <div className="CouponsType">
                                                                    Coupons
                                                                </div>
                                                            </div>
                                                            <div style={{ display: "flex", flexDirection: "column", gap: "0.8rem" }}>
                                                                <label className="fare-label-name-data">Frequency of Successful Referral [In number] </label>
                                                                <Field name="frequency">
                                                                    {({ field }) => (
                                                                        <Input
                                                                            {...field}
                                                                            type="number"
                                                                            min="1"
                                                                            disabled={isDisabled}
                                                                            onChange={(e) => {
                                                                                if (!isDisabled) {
                                                                                    formikBag.setFieldValue("frequency", e.target.value);
                                                                                }
                                                                            }}
                                                                            className="form_data"
                                                                            placeholder="Enter Value"
                                                                            error={
                                                                                formikBag.touched.frequency && formikBag.errors.frequency
                                                                                    ? formikBag.errors.frequency
                                                                                    : null
                                                                            }
                                                                        />
                                                                    )}
                                                                </Field>
                                                                {formikBag.touched.rewardType && formikBag.errors.rewardType && (
                                                                    <div className="error">{formikBag.errors.rewardType}</div>
                                                                )}
                                                            </div>

                                                            <div style={{ display: "flex", flexDirection: "column", gap: "0.8rem" }}>
                                                                <label className="fare-label-name-data">Enter Coupon Discount Value [in %]</label>
                                                                <Field name="cuponDiscount">
                                                                    {({ field }) => (
                                                                        <Input
                                                                            {...field}
                                                                            type="number"
                                                                            min="1"
                                                                            max="100"
                                                                            disabled={isDisabled}
                                                                            onChange={(e) => {
                                                                                const rawValue = e.target.value;

                                                                                if (rawValue === "") {
                                                                                    formikBag.setFieldValue("cuponDiscount", "");
                                                                                } else {
                                                                                    const value = Number(rawValue);
                                                                                    if (!isDisabled && value <= 100) {
                                                                                        formikBag.setFieldValue("cuponDiscount", value);
                                                                                    }
                                                                                }
                                                                            }}
                                                                            className="form_data"
                                                                            placeholder="Enter percentage"
                                                                            error={
                                                                                formikBag.touched.cuponDiscount && formikBag.errors.cuponDiscount
                                                                                    ? formikBag.errors.cuponDiscount
                                                                                    : null
                                                                            }
                                                                        />
                                                                    )}
                                                                </Field>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Buttons */}
                                                <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginTop: "1rem" }}>
                                                    <Button type="submit" disabled={isLoading}>
                                                        {isLoading ? "Saving..." : "Save"}
                                                    </Button>
                                                    <CancelButton type="button" onClick={() => formikBag.resetForm()}>
                                                        Cancel
                                                    </CancelButton>
                                                </div>
                                            </div>
                                        </Form>
                                    );
                                }}



                            </Formik>
                        </DashboardHeading>
                    </ProfileDetailForm>
                </DashboardWrapper>
            </DashboardContainer>

            {isLoading && <Overlay />}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        locationData: state.locations,
        defaultState: state.defaultState,
        sidebar: state.sidebar,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setUsers: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_USER,
                updatedUser: updatedValue,
            });
        },
        setDefaultState: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_DEFAULT,
                updateDefault: updatedValue,
            });
        },
        setSidebar: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_SIDEBAR,
                updateSidebar: updatedValue,
            });
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CommissionSettings);
